import { AppState } from "../../state";

export const getStaffLoginState = (state: AppState) => state.staffLogin;
